import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Brush,
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import { labelFormatterMoneyAsInteger } from '../../../../../shared/formatters/formatters';
import { formatStringCurrency } from '../../../../../shared/utils';
import { AveragePricePerSqMtChartData } from './types';
import {
  getMaxValueInArray,
  getMinValueInArray,
} from '../../../../../helpers/arrayHelper';

export const AveragePricePerSqMt: React.FC = () => {
  const { requestStatusSecondary } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  const { chartsDataSecondary } = useSelector(
    (state: any) => state.offersSecondaryState
  );
  return (
    <ChartCard
      data={chartsDataSecondary['price_variation_by_period']}
      Chart={AveragePricePerSqMtChart}
      cy={'AveragePricePerSqMt'}
      id={'averagePricePerSqMt'}
      requestStatus={requestStatusSecondary['averagePricePerSqMt']}
    />
  );
};

export const AveragePricePerSqMtChart: React.FC<
  IChartProps<AveragePricePerSqMtChartData[]>
> = ({ data, cy, id }) => {
  data = data?.map((el) => ({
    ...el,
    value: parseFloat(el?.value)?.toFixed(0),
  }));

  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterMoneyAsInteger];
  const isYearOnly = data.every((el: any) => el.type === 'year');

  const minY = Math.trunc(0.9 * getMinValueInArray(data, 'value'));
  const maxY = Math.trunc(1.1 * getMaxValueInArray(data, 'value'));
  return (
    <ResponsiveContainer data-cy={`PriceVariationByPeriod${cy}`}>
      <LineChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <XAxis
          dataKey="id"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <YAxis domain={[minY, maxY]} />
        <Line
          isAnimationActive={false}
          type="monotone"
          name="Mediana"
          dataKey="value"
          stroke="#492273"
        >
          {isYearOnly && (
            <LabelList
              dataKey="value"
              position="top"
              formatter={(value: number) =>
                formatStringCurrency(value.toString())
              }
            />
          )}
        </Line>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
};
